/**
 * `core/wordpress/mwwpform/mwwpformPrivacyCheck.js`
 * - プライバシーポリシーへの同意ボタン
 *
 * 使用方法:
 * - import {mwwpformPrivacyCheck} from "../wordpress/mwwpform/mwwpformPrivacyCheck.js";
 */


import { barbaEventObserver } from "../../barba/utils/barbaEventObserver.js";


export function mwwpformPrivacyCheck() {
  console.log("🔒 Handling Privacy Agreement...");

  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  const mwWpFormPrivacy = document.querySelector('#privacy-1');

  if (!mwWpFormPrivacy || !mwWpFormSubmit) return;
  // Sync submit button state with current checkbox value (handles back/forward cache & restored state)
  const syncSubmitState = () => {
    mwWpFormSubmit.disabled = !mwWpFormPrivacy.checked;
  };
  syncSubmitState();

  // Change handler (fires when user toggles the checkbox)
  const onPrivacyChange = (event) => {
    mwWpFormSubmit.disabled = !event.target.checked;
  };

  // Also listen to 'input' for some browsers / autofill cases
  mwWpFormPrivacy.addEventListener('change', onPrivacyChange);
  mwWpFormPrivacy.addEventListener('input', onPrivacyChange);

  // Observe with Barba for auto-cleanup on page transitions
  barbaEventObserver.observeEvents([
    [mwWpFormPrivacy, 'change', onPrivacyChange],
    [mwWpFormPrivacy, 'input', onPrivacyChange]
  ]);

  // Handle BFCache/page restore and form reset so state stays in sync without requiring a manual uncheck→check
  const onPageShow = () => syncSubmitState();
  window.addEventListener('pageshow', onPageShow);
  barbaEventObserver.observeEvents([[window, 'pageshow', onPageShow]]);

  const formEl = document.querySelector('.mw_wp_form');
  if (formEl) {
    const onFormReset = () => setTimeout(syncSubmitState, 0);
    formEl.addEventListener('reset', onFormReset);
    barbaEventObserver.observeEvents([[formEl, 'reset', onFormReset]]);
  }
}
